var exports = {
  "SG": "Okey101Melds.module__melds___UERsd2",
  "Ie": "Okey101Melds.module__empty___UERsd2",
  "jg": "Okey101Melds.module__meld___UERsd2",
  "os": "Okey101Melds.module__tiles___UERsd2",
  "jp": "Okey101Melds.module__badges___UERsd2",
  "qS": "Okey101Melds.module__badge___UERsd2",
  "so": "Okey101Melds.module__scores___UERsd2",
  "pG": "Okey101Melds.module__caption___UERsd2",
  "Kv": "Okey101Melds.module__scoreName___UERsd2",
  "kE": "Okey101Melds.module__scoreValue___UERsd2",
};

module.exports = exports;
